/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { css } from '@emotion/react';
import linkifyIt from 'linkify-it';
import tlds from 'tlds';

const linkify = linkifyIt();
linkify.tlds(tlds);

const Image = (props) => {
  const { isPublish = false, block, className, theme = {}, ...otherProps } = props;
  // leveraging destructuring to omit certain properties from props
  const {
    blockProps, // eslint-disable-line no-unused-vars
    customStyleMap, // eslint-disable-line no-unused-vars
    customStyleFn, // eslint-disable-line no-unused-vars
    decorator, // eslint-disable-line no-unused-vars
    forceSelection, // eslint-disable-line no-unused-vars
    offsetKey, // eslint-disable-line no-unused-vars
    selection, // eslint-disable-line no-unused-vars
    tree, // eslint-disable-line no-unused-vars
    contentState,
    blockStyleFn, // eslint-disable-line no-unused-vars
    preventScroll, // eslint-disable-line no-unused-vars
    ...elementProps
  } = otherProps;
  const { src, alt, url } = contentState.getEntity(block.getEntityAt(0)).getData();

  let isLinked = false;
  if (isPublish && typeof url !== 'undefined' && url !== '') {
    const link = linkify.match(url);
    if (typeof link !== 'undefined' && link !== null) {
      isLinked = true;
    }
  }

  if (isPublish && isLinked) {
    return (
      <a
        href={url}
        target='_blank'
        css={css`
          max-width: 50%;
          margin: 0 auto;
          img {
            max-width: 100% !important;
          }
        `}
      >
        <img
          {...elementProps}
          alt={alt}
          src={src}
          url={url}
          role='presentation'
          className={className}
          css={[
            css`
              pointer-events: none !important;
              box-shadow: none !important;
              cursor: pointer !important;
            `,
            theme.image,
          ]}
        />
      </a>
    );
  }

  return (
    <img
      {...elementProps}
      alt={alt}
      src={src}
      url={url}
      role='presentation'
      className={className}
      css={[
        css`
          pointer-events: none;
          cursor: pointer !important;
        `,
        theme.image,
      ]}
    />
  );
};

export default Image;
